<div class="flex flex-wrap gap-4">
  <div
    class="flex flex-col justify-center items-center gap-[10px] cursor-pointer rounded-xl border border-dashed border-[#25508ecc] bg-[#FFFFFF] hover:bg-[#EBF0FA] w-[220px] h-[200px]"
    [ngClass]="{
      'border-dashed': isVaultView
    }"
    (click)="addNewVault()"
  >
    <div class="w-[64px] h-[64px] flex justify-center items-center bg-[#EBF0FA] rounded-full">
      <mat-icon class="text-[#25508E] text-[33px] leading-[33px] h-[34px] w-[34px]">add</mat-icon>
    </div>
    <div
      class="text-[#1E1E20] text-center font-open-sans font-semibold text-base leading-[140%] tracking-[0.08px] max-w-[151px] overflow-hidden text-ellipsis whitespace-nowrap capitalize"
    >
      Add Vault
    </div>
  </div>
  @if(isVaultView){ @for (vault of cardList; let i = $index; track vault) {
  <div
    class="relative cursor-pointer hover:shadow-[0_4px_10px_0_#63636333] transition-all duration-200 w-[220px] h-[200px] active:bg-[#EBF0FA] active:shadow-none rounded-xl border border-[#53565b33] bg-[#FFFFFF]"
    (click)="openVault(vault, $event, i)"
  >
    <div class="absolute top-[12px] right-[12px]">
      <div class="flex justify-center items-center w-fit gap-1">
        <div class="w-[30px] h-[30px] flex justify-center items-center">
          <img [src]="getValutIcon(vault?.type)" class="w-[30px] h-[30px]" />
        </div>
        @if(!isHideMatMenu){
        <button
          class="flex items-center justify-center custom-menu-button h-[26px] w-[26px] p-0"
          mat-menu-trigger
          [matMenuTriggerFor]="vaultMenu"
          (click)="$event.stopPropagation()"
        >
          <mat-icon class="text-k-blue">more_vert</mat-icon>
        </button>
        }
      </div>

      <mat-menu #vaultMenu="matMenu" class="custom-popup-menu-panel mt-1" yPosition="below" xPosition="before">
        <button mat-menu-item (click)="openManageMembersDialog(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/manage-member.svg" />
            Manage Members
          </div>
        </button>
        <button mat-menu-item (click)="manageSharing(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/manage-sharing.svg" />
            Manage Sharing
          </div>
        </button>
        <button mat-menu-item (click)="openDialogToRenameVault(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/vault-rename.svg" />
            Rename
          </div>
        </button>
        @if(!vault.is_system && (stateObject.userId === vault.user_id)){
        <button mat-menu-item (click)="deleteVault(vault)">
          <div class="flex items-center gap-2 text-[#EB5757] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/delete-vault.svg" />
            Delete Vault
          </div>
        </button>
        }
      </mat-menu>
    </div>
    <div class="absolute top-[10px] left-[10px]">
      <mat-checkbox
        type="checkbox"
        class="checkbox-input"
        [(ngModel)]="vault.selected"
        [checked]="vault.selected"
        [value]="vault.selected"
        (change)="onVaultSelectedChange($event, vault)"
        (click)="$event.stopPropagation()"
      ></mat-checkbox>
    </div>
    <div class="h-[124px] flex flex-col justify-center items-center gap-2 mt-[50px]">
      <div class="w-[68px] h-[68px] flex justify-center items-center">
        <div class="flex">
          @for (member of (vault?.vaultMembers).slice(0, showNumberOfAvatar); track member; let isFirst = $first) {
          <div
            class="shared-users-image shared-users-image__wrapper"
            matTooltip="{{ member?.memberUser?.first_name + ' ' + member?.memberUser?.last_name }}"
          >
            <div class="hover:ml-0 hover:translate-y-[-0.2rem] hover:scale-[1.03]" [ngClass]="{ 'ml-0': isFirst, 'ml-[-5px]': !isFirst }">
              <ngx-avatars
                id="kinnect-avatar"
                size="32"
                src="{{ member.memberUser?.profile_image_url }}"
                name="{{ member.memberUser?.first_name + ' ' + member.memberUser?.last_name }}"
                [round]="true"
                initialsSize="2"
                class="vault-card-avatar"
              ></ngx-avatars>
            </div>
          </div>
          } @if ((vault?.vaultMembers)?.length > showNumberOfAvatar) {
          <div
            class="w-[32px] h-[32px] rounded-full bg-[#25508E] text-[#FFFFFF] text-center font-open-sans font-normal text-[12px] flex items-center justify-center ml-[-5px] outline-[2px] outline-white outline"
          >
            +{{ vault?.vaultMembers?.length - showNumberOfAvatar }}
          </div>
          }
        </div>
      </div>
      <div
        appTooltip
        [toolTipText]="vault?.name"
        class="text-[#1E1E20] text-center font-open-sans font-semibold text-base leading-[140%] tracking-[0.08px] max-w-[151px] overflow-hidden text-ellipsis whitespace-nowrap capitalize"
      >
        {{ vault?.name }}
      </div>
      <div class="text-[#425466] text-center font-open-sans font-normal text-sm leading-[140%] tracking-[0.07px] text-transform: capitalize;">
        {{ vault?.cnt }} {{ vault?.cnt | pluralize : 'Item' }}
      </div>
      <div class="ml-2 bottom-[20px] right-[15px]" *ngIf="isDuplicateVault(vault)" style="position: absolute">
        <div class="w-7 h-7 rounded-full flex items-center justify-center" style="background-color: #fff0c3">
          <img src="assets/images/humbleicons_duplicate_color-icon.svg" alt="Duplicate" class="w-4 h-4" matTooltip="Duplicate Vault Name" />
        </div>
      </div>
    </div>
  </div>
  } }@else{ @for (vault of cardList; let i = $index; track vault) {
  <div
    class="rounded-[12px] border border-[rgba(83,86,91,0.20)] bg-white w-[220px] h-[200px] relative cursor-pointer hover:shadow-[0_4px_10px_0_#63636333] transition-all duration-200 active:bg-[#EBF0FA] active:shadow-none"
    (click)="openVault(vault, $event, i)"
  >
    <div class="absolute top-[12px] right-[12px]">
      <div class="flex justify-center items-center w-fit gap-1">
        <div
          class="rounded border border-[rgba(84,117,192,0.40)] bg-[#EBF0FA] inline-flex h-6 px-2 py-1 justify-center items-center text-[#5475C0] text-center font-semibold font-open-sans text-xs tracking-[0.05px]"
        >
          {{ vault?.type ? (vault?.type | titlecase) : '' }}
        </div>
        @if(!isHideMatMenu){
        <button
          class="flex items-center justify-center custom-menu-button h-[26px] w-[26px] p-0"
          mat-menu-trigger
          [matMenuTriggerFor]="vaultMenu"
          (click)="$event.stopPropagation()"
        >
          <mat-icon class="text-[#010B18]">more_vert</mat-icon>
        </button>
        }
      </div>

      <mat-menu #vaultMenu="matMenu" class="custom-popup-menu-panel mt-1" yPosition="below" xPosition="before">
        <button mat-menu-item (click)="openManageMembersDialog(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/manage-member.svg" />
            Manage Members
          </div>
        </button>
        <button mat-menu-item (click)="manageSharing(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/manage-sharing.svg" />
            Manage Sharing
          </div>
        </button>
        <button mat-menu-item (click)="openDialogToRenameVault(vault)">
          <div class="flex items-center gap-2 text-[#18191C] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/vault-rename.svg" />
            Rename
          </div>
        </button>
        @if(!vault.is_system && (stateObject.userId === vault.user_id)){
        <button mat-menu-item (click)="deleteVault(vault)">
          <div class="flex items-center gap-2 text-[#EB5757] font-open-sans font-semibold text-sm letter-spacing-[0.14px]">
            <img src="assets/images/vault/delete-vault.svg" />
            Delete Vault
          </div>
        </button>
        }
      </mat-menu>
    </div>
    <div class="absolute top-[14px] left-[14px]">
      <div class="flex shared-images">
        @for (member of (vault?.vaultMembers).slice(0, showNumberOfAvatar); track member; let isFirst = $first) {
        <div
          class="shared-users-image shared-users-image__wrapper"
          matTooltip="{{ member?.memberUser?.first_name + ' ' + member?.memberUser?.last_name }}"
        >
          <div class="ml-[-5px] hover:translate-y-[-0.2rem] scale-[1.03] ml-0;" [ngClass]="{ 'ml-0': isFirst }">
            <ngx-avatars
              id="kinnect-avatar"
              size="32"
              src="{{ member.memberUser?.profile_image_url }}"
              name="{{ member.memberUser?.first_name + ' ' + member.memberUser?.last_name }}"
              [round]="true"
              initialsSize="2"
              class="vault-card-avatar"
            ></ngx-avatars>
          </div>
        </div>
        } @if ((vault?.vaultMembers)?.length > showNumberOfAvatar) {
        <div
          class="w-8 h-8 rounded-full bg-[#25508E] text-white text-xs flex items-center justify-center ml-[-5px] outline outline-[2px] outline-white;"
        >
          +{{ vault?.vaultMembers?.length - showNumberOfAvatar }}
        </div>
        }
      </div>
    </div>
    <div class="h-[124px] flex flex-col justify-center items-center gap-2 mt-[50px]">
      <div class="w-[68px] h-[68px] flex justify-center items-center">
        <img [src]="getValutIcon(vault?.type)" />
      </div>
      <div
        appTooltip
        [toolTipText]="vault?.name"
        class="text-[#1E1E20] text-center font-semibold font-open-sans text-[16px] leading-[140%] tracking-[0.08px] capitalize max-w-[151px] overflow-hidden text-ellipsis whitespace-nowrap"
      >
        {{ vault?.name }}
      </div>
      <div class="text-[#425466] text-center font-[400] font-['Open_Sans'] text-[14px] leading-[140%] tracking-[0.07px] capitalize">
        {{ vault?.cnt }} {{ vault?.cnt | pluralize : 'Item' }}
      </div>
      <div class="ml-2 bottom-[20px] right-[15px]" *ngIf="isDuplicateVault(vault)" style="position: absolute">
        <div class="w-7 h-7 rounded-full flex items-center justify-center" style="background-color: #fff0c3">
          <img src="assets/images/humbleicons_duplicate_color-icon.svg" alt="Duplicate" class="w-4 h-4" matTooltip="Duplicate Vault Name" />
        </div>
      </div>
    </div>
  </div>
  }}
</div>
